import script from "./SALModalDetalle.vue?vue&type=script&setup=true&lang=js"
export * from "./SALModalDetalle.vue?vue&type=script&setup=true&lang=js"

import "./SALModalDetalle.vue?vue&type=style&index=0&id=3383a5fa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3383a5fa"]])

export default __exports__